import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import "../../styles/workouts-new/workouts.css";
import HelmetWrapper from "../../HelmetWrapper";
import { selectAuth } from "../../components/auth/auth.selector";
import CommonStructured from "../../components/common-components/CommonStructured";
import CommonFilterStructure from "../../components/common-components/CommonFilterStructure";
import ReactVortoxSpinner from "../../components/common-components/ReactVortoxSpinner";
import WorkoutPackageCards from "../../components/workouts-new/workout-packages/WorkoutPackageCards";
import AllWorkoutPackages from "../../components/workouts-new/workout-packages/AllWorkoutPackages";
import {
  fetchAllWorkoutPackageData,
  fetchWorkoutPackageStatsData,
} from "../../redux/workout-reducers/workoutApis";

const WorkoutPackages = () => {
  const dispatch = useDispatch();
  const authData = useSelector(selectAuth);
  const userInfoData = authData.user;

  const { statsLoading, workoutPackageStats } = useSelector(
    (state) => state.workoutApi
  );

  const iniModvalues = {
    isModOpen: false,
    cardName: "",
    rowData: "",
    workoutArray: [],
  };
  const [modValues, setModValues] = useState(iniModvalues);
  const [isPage, setIsPage] = useState(0);
  const iniAllFilter = {
    filterType: "",
    selExerciseName: "",
    selPlanSuitableFor: "",
    isActive: "",
    searchString: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    limit: 10,
    page: isPage + 1,
    plan_type:
      allFilters.filterType?.toLowerCase() === "total"
        ? ""
        : allFilters.filterType,
    focused_category: allFilters.selCategoryName?.value
      ? allFilters.selCategoryName?.value
      : "",
    exercise_id: allFilters.selExerciseName?.value
      ? allFilters.selExerciseName?.value
      : "",
    plan_suitable_for: allFilters.selPlanSuitableFor?.value
      ? allFilters.selPlanSuitableFor?.value
      : "",
    status: allFilters.isActive?.value ? allFilters.isActive.value : "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);

  function onResetFilters() {
    setAllFilters(iniAllFilter);
    setFilters(iniFilters);
    setSearchFilterApplied(false);
    setIsPage(0);
  }

  function onCloseModalvalues() {
    setModValues(iniModvalues);
  }

  const onClickSearch = () => {
    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
      setIsPage(0);
    }
  };

  function getWorkoutPackgeStats(filters = {}) {
    dispatch(
      fetchWorkoutPackageStatsData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  function getWorkoutPackages(filters) {
    dispatch(
      fetchAllWorkoutPackageData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    getWorkoutPackgeStats();
  }, []);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      plan_type:
        allFilters.filterType?.toLowerCase() === "total"
          ? ""
          : allFilters.filterType || "",
      focused_category: allFilters.selCategoryName?.value
        ? allFilters.selCategoryName?.value
        : "",
      exercise_id: allFilters.selExerciseName?.value
        ? allFilters.selExerciseName?.value
        : "",
      plan_suitable_for: allFilters.selPlanSuitableFor?.value
        ? allFilters.selPlanSuitableFor?.value
        : "",
      status: allFilters.isActive?.value ? allFilters.isActive.value : "",
    }));
  }, [
    allFilters.filterType,
    allFilters.selCategoryName,
    allFilters.selExerciseName,
    allFilters.selPlanSuitableFor,
    allFilters.isActive,
    isPage,
  ]);

  useEffect(() => {
    getWorkoutPackages(filters);
  }, [filters]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  return (
    <HelmetWrapper title="WTF: Workout Packages">
      <Container className="bg-cloud-k px-50px" fluid>
        <Row>
          <Col>
            <Row>
              <Col>
                {statsLoading ? (
                  <ReactVortoxSpinner />
                ) : (
                  <WorkoutPackageCards
                    workoutStats={workoutPackageStats}
                    setCardValues={setAllFilters}
                    setIsPage={setIsPage}
                  />
                )}
              </Col>
            </Row>
          </Col>
        </Row>

        <Row>
          <Col>
            <Row>
              <Col>
                <CommonStructured
                  pageHeading={"All Workout Package"}
                  createBtnTxt={"+ Add workout package"}
                  onClickCreateBtn={() =>
                    setModValues((prevs) => ({
                      ...prevs,
                      isModOpen: true,
                      cardName: "add",
                    }))
                  }
                />
              </Col>
            </Row>
          </Col>
        </Row>

        <Row>
          <Col>
            <CommonFilterStructure
              from={"workout-packages"}
              decryptedText={userInfoData}
              onClickReset={onResetFilters}
              filters={allFilters}
              setFilters={setAllFilters}
              onClickSearch={onClickSearch}
              searchFilterApplied={searchFilterApplied}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <AllWorkoutPackages
              // tbDatas={workoutPackages}
              isPage={isPage}
              setIsPage={setIsPage}
              callFunction={() => {
                getWorkoutPackgeStats(filters);
                getWorkoutPackages(filters);
              }}
              userInfoData={userInfoData}
              modValues={modValues}
              setModValues={setModValues}
              onCloseModalvalues={onCloseModalvalues}
            />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default WorkoutPackages;
